import { SessionsState } from '../../store/state';
import { SessionAction, SessionActions } from '../actions/sessions';

const initialState: SessionsState = {
  data: null,
  isLoading: false,
  error: '',
};

const sessionsReducer = (state: SessionsState = initialState, action: SessionAction): SessionsState => {
  switch (action.type) {
    case SessionActions.LoadSessions:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case SessionActions.LoadSessionsSuccess:
      return {
        isLoading: false,
        error: null,
        data: action.payload,
      };
    case SessionActions.LoadSessionsError:
      return {
        isLoading: false,
        error: action.payload,
        data: null,
      };
    case SessionActions.StartSessionsPoll:
      return {
        isLoading: false,
        error: null,
        data: null,
      };  
    default:
      return state;
  }
};

export default sessionsReducer;
